import { API } from 'src/utils/interceptor'

const PROPOSE_TIMEOUT_MS = 120_000

function getErrorMessage(error, fallback) {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallback
  )
}

/**
 * Propose a manual order from an uploaded invoice/receipt and/or notes.
 */
export async function proposeManualOrderFromUpload({
  venueId,
  file = null,
  notes = '',
} = {}) {
  if (!venueId) throw new Error('venueId is required')

  const body = new FormData()
  if (file) body.append('file', file)
  if (notes) body.append('notes', notes)

  try {
    const response = await API.post(
      'api2',
      `venues/${venueId}/manual-order-proposals`,
      { body, timeout: PROPOSE_TIMEOUT_MS },
    )
    return response?.data || response
  } catch (error) {
    throw new Error(
      getErrorMessage(error, 'Could not build a proposed order with Ollie'),
    )
  }
}

/**
 * Propose a manual order from an existing invoices-library document.
 */
export async function proposeManualOrderFromInvoice({
  invoiceId,
  notes = '',
} = {}) {
  if (!invoiceId) throw new Error('invoiceId is required')

  try {
    const response = await API.post(
      'api2',
      `invoices/${invoiceId}/propose-manual-order`,
      {
        body: notes ? { notes } : {},
        timeout: PROPOSE_TIMEOUT_MS,
      },
    )
    return response?.data || response
  } catch (error) {
    throw new Error(
      getErrorMessage(
        error,
        'Could not build a matching manual order from this invoice',
      ),
    )
  }
}

/**
 * After supplier confirm: match AI line guesses to that supplier's catalogue
 * (or return plain guessed lines for a manual / free-text supplier).
 */
export async function resolveManualOrderProposalProducts({
  venueId,
  supplierId = null,
  lineItems = [],
  lineItemsIncludeVat = null,
} = {}) {
  if (!venueId) throw new Error('venueId is required')

  try {
    const response = await API.post(
      'api2',
      `venues/${venueId}/manual-order-proposals/products`,
      {
        body: {
          supplierId: supplierId || undefined,
          lineItems,
          lineItemsIncludeVat,
        },
        timeout: PROPOSE_TIMEOUT_MS,
      },
    )
    return response?.data || response
  } catch (error) {
    throw new Error(
      getErrorMessage(error, 'Could not match products for this supplier'),
    )
  }
}
